export const HEADER_BLOCK_S19 = {
  "temp":{
    "templateId":19
  },
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "Transforming Businesses with Innovative Software Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "3.75rem",
          "line-height": "1",
          "font-family": "'Old Standard TT'",
          "font-weight": "400",
          "font-family-cust": "Old Standard TT",
          "font-family-bk": "'Lato', sans-serif"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "3rem",
          "line-height": "1"
        },
        "stylePropsTab": {
          "font-size": "3.75rem",
          "line-height": "1"
        }
      },
      {
        "text": "Check out some of our notable projects and success stories. From startups to enterprises, we've helped numerous organizations achieve their goals.",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.5rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 100px 0px 20px"
        },
        "alignStylePropsTab": {
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsTab": {
          "font-size": "1.5rem",
          "line-height": "2rem"
        },
        "stylePropsMob": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 0px",
      "padding": "0px 0px 0px 0px"
    },
    "buttonAlign": "start",
    "buttons": [
      {
        "styleProps": {
          "padding": "12px 30px 12px 30px",
          "border-width": "1px",
          "color": "#333333",
          "background-color": "#ffbc47",
          "border-radius": "9999px",
          "border-color": "#ffffff33"
        },
        "alt": "Google Play Store",
        "href": "#",
        "text": "Explore",
        "openType": "sametab"
      },
      {
        "text": "Learn more  ➜",
        "styleProps": {
          "color": "#333333",
          "border-color": "#ffa611",
          "background-color": "#ffffff",
          "border-width": "1px",
          "border-radius": "9999px",
          "padding": "12px 30px 12px 30px"
        },
        "href": "#",
        "openType": "sametab"
      }
    ],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    },
    "buttonsStylePropsTab": {
      "padding": "0px 0px 0px 0px"
    }
  },
  "imageType": "image",
  "imageVideoPostion": "right",
  "imageBlock": {
    "image": "https://d11lx8wl9i3fvs.cloudfront.net/1681109394227/1746167395471.png",
    "styleProps": {
      "margin": "20px 20px 20px 20px",
      "border-radius": "0px"
    },
    "outerStyleProps": {
      "border-radius": "1.5rem"
    },
    "tagStyleProps": {
      "border-radius": "1.5rem"
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1746165677618,
  "blockId": 1746165677618,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": "Old Standard TT"
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "containerStyleProps": {
    "background-color": "",
    "border-radius": "1rem",
    "padding": "0px 0px 0px 0px"
  }
}